module.exports = __webpack_public_path__ + "img/4-(3).69ae8af1.jpg";